<template>
    <div class="related-entries">
        <category-display v-bind="category"
                :facets="['in-cms']"
                :entry-facets="['in-cms']"
                :entry-title-max-length="120"
                :entries="getEntriesOfCategory(category)"
                :key="category.id"/>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import CategoryDisplay from 'framework/components/category-display/category-display';

    export default {
        components: {
            CategoryDisplay,
        },
        props: {
            categorySlug: {
                type: String,
                required: true,
            },
        },
        computed: {
            ...mapGetters('project-data', ['getEntriesByCategorySlug', 'getResourceBySlug']),
            category() {
                return this.getResourceBySlug(this.categorySlug);
            },
        },
        methods: {
            getEntriesOfCategory({ slug }) {
                return this.getEntriesByCategorySlug(slug);
            },
        },
    };
</script>
